// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import { PropTypes } from 'prop-types';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { PLPLabels, PLP_SORT_LABELS } from '@tcp/core/src/utils/labels/browse/PLP.labels';
import { capitalizeWords } from '@tcp/core/src/utils/utils';
import { getLocator } from '../../../../../../../utils';
import style from '../ReadMore.style';

class ReadMore extends React.PureComponent {
  plpLabelsObj = getLabelFromCopyOrFromTranslation('PLP.seoText', PLPLabels);

  plpLabelsObj2 = getLabelFromCopyOrFromTranslation(PLP_SORT_LABELS, PLPLabels);

  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
    };
  }

  handleReadMoreView = (e) => {
    this.setState({ isExpanded: e.target.checked });
  };

  countAndAppendDivTag = (htmlString, isFacetedNavigationEnabled, appliedFilterIdsAndLength) => {
    const sizeLabel = renderLabel(this.plpLabelsObj2.lbl_size, 'lbl_size');

    // Count the number of <div occurrences in the input string
    let updatedHtmlString = htmlString?.replace(/<color> /g, '');
    updatedHtmlString = updatedHtmlString?.replace(/<c_color> /g, '');
    updatedHtmlString = updatedHtmlString?.replace(/<size> /g, '');
    updatedHtmlString = updatedHtmlString?.replace(/<s_size> /g, '');

    const {
      filterCount,
      filterCountFromURL,
      singleColorFilterValue = '',
      singleSizeFilterValue = '',
    } = appliedFilterIdsAndLength || {};
    if (
      isFacetedNavigationEnabled &&
      (filterCount === 1 || filterCountFromURL === 1) &&
      singleColorFilterValue
    ) {
      updatedHtmlString = htmlString?.replace(/<color>/g, singleColorFilterValue.toLowerCase());
      updatedHtmlString = updatedHtmlString?.replace(
        /<c_color>/g,
        capitalizeWords(singleColorFilterValue)
      );
    }
    if (
      isFacetedNavigationEnabled &&
      (filterCount === 1 || filterCountFromURL === 1) &&
      singleSizeFilterValue
    ) {
      updatedHtmlString = htmlString?.replace(
        /<size>/g,
        `${sizeLabel?.toLowerCase()} ${singleSizeFilterValue}`
      );
      updatedHtmlString = updatedHtmlString?.replace(
        / <s_size>/g,
        `: ${sizeLabel} ${singleSizeFilterValue}`
      );
    }
    // Count the number of <div and </div> occurrences in the input string
    const openingDivCount = (updatedHtmlString.match(/<div/g) || []).length;
    const closingDivCount = (updatedHtmlString.match(/<\/div>/g) || []).length;

    // Check if there are missing closing </div> tags
    if (openingDivCount > closingDivCount) {
      const missingDivTags = openingDivCount - closingDivCount;
      updatedHtmlString += '</div>'.repeat(missingDivTags);
    } else if (openingDivCount < closingDivCount && updatedHtmlString.endsWith('</div>')) {
      const missingDivTags = closingDivCount - openingDivCount;
      // Check if there's one extra closing </div> at the end
      updatedHtmlString = missingDivTags === 1 && updatedHtmlString.slice(0, -6); // Remove the last </div> (length of "</div>" is 6)
    }
    return updatedHtmlString;
  };

  render() {
    const readMore = renderLabel(this.plpLabelsObj.lbl_read_more, 'lbl_read_more');
    const readLess = renderLabel(this.plpLabelsObj.lbl_read_less, 'lbl_read_less');
    const { description, className, isFacetedNavigationEnabled, appliedFilterIdsAndLength } =
      this.props;
    const { isExpanded } = this.state;
    const descriptionNew =
      description &&
      this.countAndAppendDivTag(description, isFacetedNavigationEnabled, appliedFilterIdsAndLength);

    return (
      <BodyCopy
        component="div"
        className={`${className} ${isExpanded && 'read-more-expanded'}`}
        tabIndex="0"
      >
        <BodyCopy
          className="body-copy"
          fontSize="fs14"
          component="div"
          color="text.primary"
          fontFamily="secondary"
          fontWeight="regular"
          textAlign="center"
          dangerouslySetInnerHTML={{ __html: descriptionNew }}
          data-locator={getLocator('plp_seo_module')}
        />

        {description && description.includes('read-more-target') && (
          <label htmlFor="categoryDescription" className="read-more-trigger">
            <input
              type="checkbox"
              className="read-more-state"
              id="categoryDescription"
              onChange={this.handleReadMoreView}
            />
            <BodyCopy
              className="read-more"
              component="p"
              fontFamily="secondary"
              fontWeight="semibold"
              textAlign="center"
              data-locator={getLocator('plp_seo_readmore')}
              tabIndex="0"
            >
              {readMore}
            </BodyCopy>
            <BodyCopy
              className="read-less"
              component="p"
              fontFamily="secondary"
              fontWeight="semibold"
              textAlign="center"
              data-locator={getLocator('plp_seo_readless')}
              tabIndex="0"
            >
              {readLess}
            </BodyCopy>
          </label>
        )}
      </BodyCopy>
    );
  }
}

ReadMore.propTypes = {
  description: PropTypes.string,
  className: PropTypes.string,
  isFacetedNavigationEnabled: PropTypes.bool,
  appliedFilterIdsAndLength: PropTypes.shape({}),
};

ReadMore.defaultProps = {
  className: '',
  description: '',
  isFacetedNavigationEnabled: false,
  appliedFilterIdsAndLength: {},
};

export default errorBoundary(withStyles(ReadMore, style));
export { ReadMore as ReadMoreVanilla };
